import { render, staticRenderFns } from "./PageGetQuote.vue?vue&type=template&id=bdbb91f2&scoped=true"
import script from "./PageGetQuote.vue?vue&type=script&lang=js"
export * from "./PageGetQuote.vue?vue&type=script&lang=js"
import style0 from "./PageGetQuote.vue?vue&type=style&index=0&id=bdbb91f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb91f2",
  null
  
)

export default component.exports